
<div style="height: 20px !important; " class="bg-blue"></div>

<main class="bg-blue">
  <app-navbar></app-navbar>
<app-header></app-header>
  <section class="py-6" >
    <div class="container">
      <div class="row d-flex align-items-center" >
        <div class="col-xxl-5  col-xl-5 col-lg-5 col-12 d-lg-flex justify-content-end">
          <div class="mt-1 mt-lg-0 position-relative">
            <img src="../../../assets/images/landing/hero.png" alt="online course"
              class="img-fluid box py-5">

          </div>
        </div>
        <div class="col-xxl-7 col-xl-7 col-lg-7 col-12 ">
          <div class="">
            <h1 class="display-2 fw-bold mb-3 text-white">{{'curated_content_updates' | translate}}
            </h1>
            <h4 class="mb-3 display-4 text-white">{{'tailored_news_insights' | translate}}</h4>
            <p class="mb-4  mb-3 text-white">{{'touch_connect_focus' | translate}}</p>
            <a routerLink="/login" class="btn btn-lg  py-3 rounded-4  shadow px-5" style="background-color:rgb(108,230,130);border-radius: 40px !important;color: #000;">
              {{'JOIN_TOUCH_CONNECT' | translate}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="py-6 bg-white" >
    <div class="container">
      <div class="row d-flex align-items-center" >

        <div class="col-xxl-7 col-xl-7 col-lg-7 col-12 ">
          <div class="">
            <h1 class="display-2 fw-bold mb-3 ail-highlighted-text">
              {{'business_insights_economic_news' | translate}}
            </h1>
            <h4 class="mb-3 display-4 ">
              {{'uncover_business_opportunities' | translate}}
            </h4>
            <p class="mb-4  mb-3 ">
              {{'touch_connect_updates' | translate}}
            </p>
            <a routerLink="/login" class="btn btn-lg  py-3 rounded-4  shadow px-5" style="background-color:rgb(108,230,130);border-radius: 40px !important;color: #000;">Join TouchConnect</a>
          </div>
        </div>
        <div class="col-xxl-5  col-xl-5 col-lg-5 col-12 d-lg-flex justify-content-end">
          <div class="mt-1 mt-lg-0 position-relative">
            <img src="../../../assets/images/landing/img-13.png" alt="online course"
              class="img-fluid box py-5">

          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="pb-lg-16 pt-5 bg-redish pb-5">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-12 col-12">
          <!-- image -->
          <div class="mb-4 mb-lg-0 rounded-4 mt-3">
            <img src="../../../assets/images/Mobile/Group 289327.png" alt="featured"
              class="img-fluid w-100  box">
          </div>
        </div>
        <div class="col-lg-6 col-md-12 col-12 mt-4 mt-lg-0">
          <!-- content -->
          <div class="ps-lg-7">
            <h2 class="display-4 mt-4 mb-3 fw-bold">
              {{'update_share_content' | translate}}
            </h2>
            <div class="mt-5 row">
              <p class="lead text-dark">
                {{'help_followers_discover' | translate}}
              </p>
             <div class="col-lg-12">
              <a routerLink="/login" class="btn btn-lg  py-3 rounded-4 text-dark shadow px-5 " style="background-color: rgb(3,205,105) !important;" >
                {{'JOIN_TOUCH_CONNECT' | translate}}
              </a>
             </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="pb-lg-16 pt-9 bg-red">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-12 col-12">
          <!-- content -->
          <div class="pe-lg-6 ps-lg-6">
            >
            <h2 class="display-4 mt-4 mb-3 fw-bold text-white">
              {{'customize_free_page' | translate}}
            </h2>
            <p class="lead text-white">
              {{'connect_socials_landing_page' | translate}}
            </p>
            <a routerLink="/login" class="btn btn-lg  py-3 rounded-4 text-dark shadow px-5" style="background-color: #E9C0E9 !important">
              {{'JOIN_TOUCH_CONNECT' | translate}}
            </a>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 col-12">
          <!-- image -->
          <div class="mt-4 mt-lg-0 ">
            <img src="../../../assets/images/Mobile/Col.png" alt="featured"
              class="img-fluid w-100  box">
          </div>
        </div>
      </div>
    </div>
  </div>
  <section class="pb-lg-16 pt-5 bg-white pb-5">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-12 col-12">
          <!-- image -->
          <div class="mb-4 mb-lg-0 rounded-4 mt-3">
            <img src="../../../assets/images/Mobile/desk.png" alt="featured"
              class="img-fluid w-100 box ">
          </div>
        </div>
        <div class="col-lg-6 col-md-12 col-12 mt-4 mt-lg-0">
          <!-- content -->
          <div class="ps-lg-7">

            <h2 class="display-4 mt-4 mb-3 fw-bold">
              {{'ultimate_method_features' | translate}}
            </h2>
            <h3>
              {{"measure_optimize_repeat1" | translate}}
            </h3>
            <a routerLink="/login" class="btn btn-lg  py-3 rounded-4 text-dark shadow px-5" style="background-color: #E9C0E9 !important">
              {{'JOIN_TOUCH_CONNECT' | translate}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="pb-lg-16 pt-9 bg-green pb-5">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-12 col-12">
          <!-- content -->
          <div class="pe-lg-6 ps-lg-6">
            >
            <h2 class="display-4 mt-4 mb-3 fw-bold text-white">
              {{'more_traffic_clicks_tools1' | translate}}
            </h2>
            <p class="lead text-white">
              {{'measure_optimize_repeat' | translate}}
            </p>
            <a routerLink="/login" class="btn btn-lg  py-3 rounded-4 text-dark shadow px-5" style="background-color: #E9C0E9 !important">
              {{'JOIN_TOUCH_CONNECT' | translate}}
            </a>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 col-12">
          <!-- image -->
          <div class="mt-4 mt-lg-0 ">
            <img src="../../../assets/images/Mobile/leftsecondMod.png" alt="featured"
              class="img-fluid box">

          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="py-lg-22 bg-blue py-5">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-12 col-12">
          <!-- image -->
          <div class="mb-4 mb-lg-0 rounded-4 mt-3">
            <img src="../../../assets/images/Mobile/Group 289327.png" alt="featured"
              class="img-fluid box">
          </div>
        </div>
        <div class="col-lg-6 col-md-12 col-12 mt-4 mt-lg-0">
          <!-- content -->
          <div class="ps-lg-7">
            <h2 class="display-4 mt-4 mb-3 fw-bold text-white">
              {{'connect_tools_link_apps' | translate}}
            </h2>
            <div class="mt-5 row">
              <p class="lead text-white">
                {{'connect_experiences_link_apps' | translate}}
              </p>
             <div class="col-lg-12">
              <a routerLink="/login" class="btn btn-lg  py-3 rounded-4 text-dark shadow px-5 " style="background-color: rgb(210,232,35) !important;" >
                {{'JOIN_TOUCH_CONNECT' | translate}}
              </a>
             </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="pb-lg-16 pt-9 bg-white py-5">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-12 col-12">
          <!-- content -->
          <div class="pe-lg-6 ps-lg-6">
            <h2 class="display-4 mt-4 mb-3 fw-bold ">
              {{'more_traffic_clicks_tools' | translate}}
            </h2>
            <p class="lead">
              
              {{'measure_optimize_repeat2' | translate}}
            </p>
            <a routerLink="/login" class="btn btn-lg  py-3 rounded-4 text-dark shadow px-5" style="background-color: #E9C0E9 !important">
              {{'JOIN_TOUCH_CONNECT' | translate}}
            </a>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 col-12">
          <!-- image -->
          <div class="mt-4 mt-lg-0 ">
            <img src="../../../assets/images/Mobile/se56.png" alt="featured"
              class="img-fluid box">

          </div>
        </div>
      </div>
    </div>
  </div>

</main>
<app-additonal-landing-page></app-additonal-landing-page>
<app-footer></app-footer>
